"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Button = {
    baseStyle: {
        fontWeight: 500,
        maxWidth: '100%',
        textDecoration: 'none',
        '.chakra-button__icon': {
            fontSize: '16px',
        },
    },
    defaultProps: {
        variant: 'outline',
    },
    sizes: {
        sm: {
            height: '32px',
            fontSize: '14px',
            minWidth: '40px',
            px: '12px',
            py: '7px',
        },
        md: {
            height: '38px',
            fontSize: '14px',
            minWidth: '40px',
            px: '12px',
            py: '7px',
        },
        lg: {
            height: '44px',
            fontSize: '16px',
            minWidth: '50px',
            px: '16px',
            py: '13px',
        },
        xl: {
            fontSize: '18px',
            height: '50px',
            minWidth: '60px',
            px: '20px',
            py: '20px',
            '.chakra-button__icon': {
                fontSize: '20px',
            },
        },
    },
    variants: {
        // DEPRECATED
        outline: {
            borderColor: 'inherit',
            bgColor: 'white',
            color: 'blueGray.900',
        },
        // DEPRECATED
        cta: {
            bgColor: 'blue.500',
            color: 'white',
            _hover: {
                bgColor: 'blue.600',
                textDecoration: 'none',
                _disabled: {
                    bgColor: 'blue.500',
                    color: 'white',
                },
            },
            _active: {
                bgColor: 'blue.700',
            },
            focusVisible: {
                boxShadow: 'outline',
            },
        },
        primary: {
            bgColor: 'Button-primary-bg',
            color: 'Button-primary-fg',
            _hover: {
                bgColor: 'Button-primary-bg_hover',
                _disabled: {
                    bgColor: 'Button-primary-bg',
                },
            },
            _active: {
                bgColor: 'Button-primary-bg_active',
            },
            _focus: {
                boxShadow: '0px 0px 0px 2px black',
            },
        },
        secondary: {
            bgColor: 'Button-bg',
            color: 'Button-fg',
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: 'Button-border',
            _hover: {
                bgColor: 'Button-bg_hover',
                _disabled: {
                    bgColor: 'Button-bg',
                },
            },
            _active: {
                bgColor: 'Button-bg_active',
            },
            _focus: {
                borderColor: 'rgba(0,0,0,0)',
                boxShadow: '0px 0px 0 2px black',
            },
        },
        tertiary: {
            bgColor: 'Button-bg',
            color: 'Button-fg',
            borderWidth: 1,
            borderColor: 'Button-border',
            borderStyle: 'none',
            _hover: {
                borderStyle: 'solid',
                bgColor: 'Button-bg_hover',
                _disabled: {
                    bgColor: 'Button-bg',
                },
            },
            _active: {
                borderStyle: 'solid',
                bgColor: 'Button-bg_active',
            },
            _focus: {
                borderColor: 'rgba(0,0,0,0)',
                boxShadow: '0px 0px 0 2px black',
            },
        },
        'blue-link': {
            bgColor: 'Button-blue-link-bg',
            color: 'Button-blue-link-fg',
            _hover: {
                bgColor: 'Button-blue-link-bg_hover',
                _disabled: {
                    bgColor: 'Button-blue-link-bg',
                },
            },
            _active: {
                bgColor: 'Button-blue-link-bg_active',
            },
            _focus: {
                boxShadow: '0px 0px 0 2px black',
            },
        },
        danger: {
            bgColor: 'Button-danger-bg',
            color: 'Button-danger-fg',
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: 'Button-danger-border',
            _hover: {
                bgColor: 'Button-danger-bg_hover',
                _disabled: {
                    bgColor: 'Button-danger-bg',
                },
            },
            _active: {
                bgColor: 'Button-danger-bg_active',
            },
            _focus: {
                borderColor: 'rgba(0,0,0,0)',
                boxShadow: '0px 0px 0 2px black',
            },
        },
        success: {
            bgColor: 'Button-success-bg',
            color: 'Button-success-fg',
            _hover: {
                bgColor: 'Button-success-bg_hover',
                _disabled: {
                    bgColor: 'Button-success-bg',
                },
            },
            _active: {
                bgColor: 'Button-success-bg_active',
            },
            _focus: {
                boxShadow: '0px 0px 0 2px black',
            },
        },
    },
};
exports.default = Button;
